/*
 * The rota's date-times arrive as ISO 8601 since KIN-2174 ("2026-10-30T13:17:00"); before it
 * they were "2026-10-30 13:17". Both are read here by position rather than by splitting on
 * the space, which silently returned the whole date-time once the space became a "T"
 * (KIN-2181).
 */

const pad = (value) => String(value).padStart(2, "0");

/** The YYYY-MM-DD part of an API date-time, in either the ISO or the legacy shape. */
export const toDatePart = (dateTime) =>
  typeof dateTime === "string" && dateTime.length >= 10
    ? dateTime.slice(0, 10)
    : undefined;

/**
 * The card's ISO start or end: the date from the API date-time, the time from the
 * LocalTime array the rota also sends (`startAt` / `endAt`, e.g. [13, 17] or [13, 17, 30]).
 *
 * It used to replace the first "HH:mm" in the date-time with the array joined by ":", which
 * gave "13:17:30:00" whenever the array carried seconds. Building it from the parts cannot.
 * With no time array the date-time itself is used, normalised to ISO.
 */
export const toScheduleDateTime = ({ dateTime, time }) => {
  const datePart = toDatePart(dateTime);

  if (!datePart) return dateTime;

  if (!Array.isArray(time) || time.length < 2) {
    return dateTime.replace(" ", "T");
  }

  const [hours, minutes, seconds = 0] = time;

  return `${datePart}T${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};
